import apiClient from '@/services/axios'

export async function post(dto) {
  var response = await apiClient.post('/VenueTasks/changeDate', dto)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update venue task.')
}